<template>
  <div class="stripe-klarna">
    <div v-if="errorMessage" class="stripe-klarna__error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import Loader from '../../mixins/Loader';
import CheckoutPayment from '../../mixins/CheckoutPayment';

let klarnaButton = null;

export default {
  name: 'StripeKlarna',
  mixins: [CheckoutPayment, Loader],
  props: {
    publishableKey: { type: String, required: true },
    formId: { type: String, required: true },
    paymentIntentUrl: { type: String, required: true },
    errorLogUrl: { type: String, required: true },
    methodInputSelector: { type: String, required: true },
    expectedInputValue: { type: String, required: true },
    customerEmail: { type: String, required: true },
    billingCountry: { type: String, default: 'FR' },
    returnUrl: { type: String, required: true },
  },
  data() {
    return {
      stripe: null,
      errorMessage: null,
      isLoading: false,
    };
  },
  async mounted() {
    this.stripe = await loadStripe(this.publishableKey);

    this.createButton();
    this.addFormSubmitListener();
  },
  methods: {
    createButton() {
      const klarnaButtonContainerId = 'klarna-button-container';

      klarnaButton = document.getElementById(klarnaButtonContainerId);

      if (!globalThis.klarnaButtonRendered) {
        klarnaButton = document.createElement('button');
        klarnaButton.id = klarnaButtonContainerId;
        klarnaButton.classList.add(
          'checkout-payment__button',
          'checkout-payment__button--klarna',
          'form-actions__btn',
          'form-actions__btn--stripe-klarna'
        );
        klarnaButton.style.display = 'none';

        const image = document.createElement('img');
        image.src = '/images/payment-methods/klarna.svg';
        image.alt = 'Logo Klarna';
        image.title = 'Klarna';

        const span = document.createElement('span');
        span.classList.add('checkout-payment__klarna-button-wrapper');
        span.innerText = 'Payer avec';
        span.appendChild(image);

        const icon = document.createElement('i');
        icon.classList.add('icon', 'icon--arrow-right');

        klarnaButton.appendChild(span);
        klarnaButton.appendChild(icon);
      }

      this.paymentButton.parentNode.appendChild(klarnaButton);

      this.addPaymentMethodChangeListener();
    },

    addPaymentMethodChangeListener() {
      const elements = Array.from(
        document.querySelectorAll(this.methodInputSelector)
      );

      elements.forEach(input =>
        input.addEventListener('change', event => {
          klarnaButton.style.display =
            this.expectedInputValue === event.target.value
              ? 'inline-flex'
              : 'none';

          this.paymentButton.style.display = this.hasVisibleCustomButtons()
            ? 'none'
            : 'inline-flex';
        })
      );

      elements
        .find(element => element.checked)
        ?.dispatchEvent(new Event('change'));
    },

    addFormSubmitListener() {
      document
        .getElementById(this.formId)
        .addEventListener('submit', this.onFormSubmit);
    },

    onFormSubmit(event) {
      const input = document.querySelector('.checkout-input__input:checked');

      if ('stripe_klarna' !== input.value) {
        return;
      }

      event.preventDefault();

      if (!this.reportFormValidity()) {
        return;
      }

      const form = document.getElementById('payment-form');
      const data = form ? JSON.parse(form.dataset.tracking || '{}') : {};
      const checkedInput = document.querySelector(
        '.checkout-input__input:checked'
      );
      if (checkedInput) {
        globalThis.dispatchEvent(
          new CustomEvent('lgf.initiateOrderPayment', {
            detail: {
              ecommerce: { ...data, payment_type: checkedInput.value },
            },
          })
        );
      }

      this.payWithKlarna();
    },

    async payWithKlarna() {
      this.errorMessage = null;
      this.isLoading = true;
      this.setLoader(); // Via votre mixin

      try {
        const clientSecret = await this.getPaymentIntent();

        const { error } = await this.stripe.confirmKlarnaPayment(clientSecret, {
          payment_method: {
            billing_details: {
              email: this.customerEmail,
              address: {
                country: this.billingCountry,
              },
            },
          },
          return_url: this.returnUrl,
        });

        if (error) {
          throw error;
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async getPaymentIntent() {
      const response = await axios.get(this.paymentIntentUrl);

      if (!response.data || !response.data.clientSecret) {
        const error = new Error('Missing client secret');
        error.debugData = response;
        throw error;
      }

      return response.data.clientSecret;
    },

    handleError(error) {
      this.isLoading = false;
      this.setLoader(false);

      console.error('[Klarna Error]', error);

      // Message utilisateur
      this.errorMessage =
        error.message || 'Une erreur est survenue avec Klarna.';

      // Log serveur (si configuré)
      if (this.errorLogUrl) {
        axios
          .post(this.errorLogUrl, {
            _token: this.getCsrfToken(),
            error: JSON.stringify({
              message: error.message,
              type: error.type,
              code: error.code,
            }),
          })
          .catch(e => console.error('Log error failed', e));
      }
    },

    getCsrfToken() {
      const meta = document.querySelector('meta[name="csrf-token"]');
      return meta ? meta.content : '';
    },
  },
};
</script>
